import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import JoinInterview from "./pages/join-interview/JoinInterview.jsx";
import Accept from "./pages/accept/Accept.jsx";
import Decline from "./pages/decline/Decline.jsx";

const theme = createTheme({
  typography: { fontFamily: "Roboto, sans-serif" },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<JoinInterview />} />
          <Route path="/accept" element={<Accept />} />
          <Route path="/decline" element={<Decline />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
